/**
 * G19/DASH-2977 (FE-3): mirrors the BE `NonDetectExclusionEffect` enum
 * (Web.Api.Core/Domain/Enums/NonDetectExclusionEffect.cs). Names the effect that
 * `CensoredDataMethod.ExcludeNonDetects` had on a Risk Register's statistical
 * sample set so the FE can render a DISTINCT reason instead of re-deriving it
 * from raw counts. `null` on the register means no exclusion was performed.
 * The integer values are a persisted contract — never re-number them.
 */
export enum NonDetectExclusionEffect {
    /** Exclusion ran and enough samples remained to compute statistics normally. */
    None = 0,
    /** N == 0 after exclusion: every value was a non-detect. */
    AllSamplesExcluded = 1,
    /** 0 < N < 3 after exclusion: below the descriptive-statistics / plot floor. */
    BelowStatisticsThreshold = 2,
    /** 3 <= N < the jurisdiction minimum after exclusion: behaves as today, cause attributed to exclusion. */
    BelowMinimumSampleCount = 3,
}
